import React, { memo } from 'react';
import NotFoundImage from '../assets/404.svg';

const NotFoundPage: React.FC = () => (
  <div className='flex flex-col space-y-5 py-12 sm:py-32'>
    <div>
      <img className='mx-auto' src={NotFoundImage} alt='404' />
    </div>
    <div className='text-center text-22 font-bold uppercase text-jm-black-title pt-23px sm:pt-0'>Page Not Found</div>
    <div className='text-16 text-jm-gray-content text-center pt-9px sm:pt-0'>The page you were looking for couldn’t be found.<br />
      It might have been removed, renamed or did not exist in the first place</div>
  </div>
);

export default memo(NotFoundPage);